import request from '@/utils/request';
import pimRequest from '@/utils/pimRequest';
import {getLocalStorage} from '@/utils/index';

export function getTargetHCP(data) {
  let url = `/api/custom/UserAlignment/GetTargetHCP_Conference?user_id=${getLocalStorage(
    'user_id',
  )}`;

  if (data.conference_id) {
    url += `&conference_id=${data.conference_id}`;
  }
  if (data.product_ids) {
    url += `&product_ids=${data.product_ids}`;
  }
  if (data.live_is_invited !== undefined) {
    url += `&live_is_invited=${data.live_is_invited}`;
  }
  if (data.onsite_is_invited !== undefined) {
    url += `&onsite_is_invited=${data.onsite_is_invited}`;
  }
  if (data.search_key) {
    url += `&search_key=${data.search_key}`;
  }
  if (data.page_index) {
    url += `&page_index=${data.page_index}`;
  }
  if (data.page_size) {
    url += `&page_size=${data.page_size}`;
  }
  if (data.scope) {
    url += `&scope=${data.scope}`;
  }

  return pimRequest({
    url,
    method: 'get',
  });
}

export function getKvpProvinceAndCities() {
  return request({
    url: `/api/standard/odata/KvpKeys?$filter=kvp_id eq 'province' or kvp_id eq 'city'&$select=kvp_id,chs,kvp_key_id,parent_kvp_key_id&$orderby=chs`,
    method: 'get',
  });
}

export function getKvpProfessionalTitles() {
  return request({
    url: `/api/standard/odata/KvpKeys?$filter=kvp_id eq 'hcp_professional_title'&$select=kvp_key_name,kvp_key_id&$orderby=sequence`,
    method: 'get',
  });
}

export function getKvpDepartments() {
  return request({
    url: `/api/standard/odata/KvpKeys?$filter=kvp_id eq 'department'&$select=kvp_key_name,kvp_key_id&$orderby=sequence`,
    method: 'get',
  });
}

// 根据城市获取医院列表
export function getInstitutionsByCity(city) {
  return request({
    url: `/api/standard/odata/Institutions?$filter=city eq '${city}'&$select=institution_name&$orderby=institution_name`,
    method: 'get',
  });
}

// 获取最近的未开始直播会议的数量
export function getRecentConferenceCount() {
  return request({
    url: `/api/standard/odata/Conferences?$filter=(status eq 'upcoming' or status eq 'warmup' or status eq 'reminder' or status eq 'highlight' or status eq 'finish')&$count=true&$top=0`,
    method: 'get',
  });
}

// 获取最近的进行中的直播会议的数量
export function getOngoingConferenceCount() {
  return request({
    url: `/api/standard/odata/Conferences?$filter=(status eq 'upcoming' or status eq 'warmup' or status eq 'reminder' or status eq 'highlight')&$count=true&$top=0`,
    method: 'get',
  });
}

// 获取最近的未开始直播会议
export function getRecentConference() {
  return request({
    url: `/api/standard/odata/Conferences?$filter=(status eq 'upcoming' or status eq 'warmup' or status eq 'reminder' or status eq 'highlight' or status eq 'finish')&$orderby=start_time asc&$expand=conference__conference_products`,
    method: 'get',
  });
}

// 获取内容
export function getContent(content_id) {
  return request({
    url: `/api/standard/odata/Contents('${content_id}')`,
    method: 'get',
  });
}

// 获取直播
export function getConference(content_id) {
  return pimRequest({
    url: `/api/custom/Conference/GetConference?content_id=${content_id}`,
    method: 'get',
  });
}

// 注册医生
export function Register(data) {
  return pimRequest({
    url: `/api/custom/Account/Register`,
    method: 'post',
    data,
  });
}

// 注册医生
export function GetRegister(open_id) {
  return pimRequest({
    url: `/api/custom/Account/GetRegister?open_id=${open_id}`,
    method: 'get',
  });
}

// 提交反馈/提问
export function SubmitFeedback(data) {
  return pimRequest({
    url: `/api/custom/Account/Feedback`,
    method: 'post',
    data,
  });
}

// 预约直播
export function ConferenceReserve(data) {
  return pimRequest({
    url: `/api/custom/Conference/Reserve`,
    method: 'post',
    data,
  });
}

// 确认现场参会
export function ConferenceAccept(data) {
  return pimRequest({
    url: `/api/custom/Conference/Accept`,
    method: 'post',
    data,
  });
}

// 获取预约
export function GetConferenceReservation(conference_id, participation_type, open_id) {
  return pimRequest({
    url: `/api/custom/Conference/GetConferenceReservation?conference_id=${conference_id}&participation_type=${participation_type}&open_id=${open_id}`,
    method: 'get',
  });
}

// 获取预约
export function GetConferenceInvitation(conference_id, content_id, open_id) {
  return pimRequest({
    url: `/api/custom/Conference/GetConferenceInvitation?conference_id=${conference_id}&content_id=${content_id}&open_id=${open_id}`,
    method: 'get',
  });
}

// 获取直播室URL
export function GetConferenceUrl(conference_id, open_id) {
  return pimRequest({
    url: `/api/custom/Conference/GetConferenceUrl?conference_id=${conference_id}&open_id=${open_id}`,
    method: 'get',
  });
}
